const localconfig = {
  authority: process.env.REACT_APP_LOGISTICS_IDENTITY_URL,
  client_id: process.env.REACT_APP_LDM_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_LDM_REDIRECT_URL,
  silent_redirect_uri: process.env.REACT_APP_LDM_SILENT_REDIRECT_URL,
  response_type: "id_token token",
  scope: "openid profile email role",
  post_logout_redirect_uri: process.env.REACT_APP_LDM_POST_LOGOUT_REDIRECT_URL,
  filterProtocolClaims: true,
  loadUserInfo: true,
  includeIdTokenInSilentRenew: false,
  monitorSession: false,
  automaticSilentRenew: true
};

const prodconfig = {
  authority: "#{IdentityServer_Authority}#",
  client_id: "#{IdentityServer_ClientId}#",
  redirect_uri: "#{IdentityServer_RedirectUri}#",
  silent_redirect_uri: "#{IdentityServer_SilentRedirectUri}#",
  response_type: "#{IdentityServer_ResponseType}#",
  scope: "#{IdentityServer_Scope}#",
  post_logout_redirect_uri: "#{IdentityServer_PostLogoutRedirectUri}#",
  filterProtocolClaims: true,
  loadUserInfo: true,
  includeIdTokenInSilentRenew: false,
  monitorSession: false,
  automaticSilentRenew: true
};

export const config = window.location.hostname === "localhost" ? localconfig : prodconfig;
export const isConsoleOn = false